<template>
    <div class="d-flex flex-column align-items-center">
        <div class="lds-dual-ring"></div>
        <div v-if="message" class="lds-message">{{message}}</div>
    </div>
</template>

<style >
    .lds-dual-ring {
        display: inline-block;
        width: 80px;
        height: 80px;
    }

        .lds-dual-ring:after {
            content: " ";
            display: block;
            width: 58px;
            height: 58px;
            margin: 8px;
            border-radius: 50%;
            border: 6px solid #fff;
            border-color: #000 transparent #000 transparent;
            animation: lds-dual-ring 1.2s linear infinite;
        }

    .lds-message {
        margin-top: 24px;
        font-size: 16px;
        font-weight: bold;
        font-family: "Montserrat";
        text-transform: uppercase;
        color: #1a1a1a;
    }


    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>

<script>

    export default {
        name: 'Loader',
        props: {
            message: null,
        }
    }

</script>